export default __webpack_public_path__ + "static/media/face.6ff9f669.png";